export default __webpack_public_path__ + "static/media/icon-megaphone.24fe673e.svg";